export default __webpack_public_path__ + "static/media/mrtq.f4503034.png";